<script lang="ts">
  import { Row, Container,Col } from "sveltestrap";
  import Chart from "./Sales.svelte";
  import GrowthOverview from "./GrowthOverview.svelte";
  import LatestActivity from "./LatestActivity.svelte";
  import RecentOrders from "./RecentOrders.svelte";
  import Transaction from "./Transaction.svelte";
  import UserActivation from "./UserActivations.svelte";
  import WelcomeUser from "./WelcomeUser.svelte";
  import { onMount } from "svelte";
  import PreLodaer from "../../../Layout/PreLoader/PreLodaer.svelte";
  let ispreloader:boolean = false;
  onMount(() => {
		setTimeout(() => {
			ispreloader = true;
		}, 1000);
	});
  
</script>
{#if !ispreloader }
<PreLodaer />
{/if}
<!-- Container-fluid starts-->
<Container fluid class="dashboard-default-sec">
  <Row>
    <Col xl="5" class="box-col-12 des-xl-100">
      <Row>
        <WelcomeUser />
      </Row>
    </Col>
    <Chart />
    <Col xl="8" class="box-col-12 des-xl-100">
      <Row>
        <GrowthOverview />
        <LatestActivity />
        <RecentOrders />
      </Row>
    </Col>
    <Col xl="4" class="box-col-12 des-xl-100">
      <Row>
        <UserActivation />
        <Transaction />
      </Row>
    </Col>
  </Row>
</Container>
<!-- Container-fluid Ends-->
